import { toast } from "react-toastify";
import { apiURL } from "../../config";

// Message of an API error response (validation field errors or e.g. the 409 "last unit admin" message)
const apiErrorMessage = (err, fallback) =>
	err.response?.data?.fieldErrors?.map((e) => e.message).join(", ") || err.response?.data?.message || fallback;

export async function getUnitMembers(axiosPrivate, unitId, phrase) {
	return axiosPrivate
		.get(`${apiURL}/organization-unit/${unitId}/members/list.json${phrase ? `?phrase=${phrase.replace(" ", "%20")}` : ""}`)
		.then((res) => {
			if (res.status > 199 && res.status < 300) {
				return res.data;
			}
		})
		.catch((err) => {
			return err.response;
		});
}

export async function getAvailableUnitMembers(axiosPrivate, phrase, unitId) {
	try {
		// Both endpoints only return users of the current user's organization
		try {
			const adminResponse = await axiosPrivate.get(`${apiURL}/admin/user.json${phrase ? "?phrase=" + phrase : ""}`);
			
			if (adminResponse.status > 199 && adminResponse.status < 300) {
				const resultUsers = [];

				for (const person of adminResponse.data) {
					let isAlreadyAdded = false;
					const units = person.organizationUnits;
					for (const unit of units) {
						if (parseInt(unit.organizationUnit.id) === parseInt(unitId)) isAlreadyAdded = true;
					}
					
					// Only include active users that are not already added to this unit
					if (!isAlreadyAdded && person.active !== false) {
						resultUsers.push(person);
					}
				}

				return resultUsers;
			}
		} catch (adminError) {
			console.log("Admin endpoint not accessible, falling back to regular endpoint");
		}

		// Fallback to regular endpoint if admin is not accessible
		const response = await axiosPrivate.get(`${apiURL}/user.json${phrase ? "?phrase=" + phrase : ""}`);
		
		if (response.status > 199 && response.status < 300) {
			const resultUsers = [];

			for (const person of response.data) {
				let isAlreadyAdded = false;
				const units = person.organizationUnits;
				for (const unit of units) {
					if (parseInt(unit.organizationUnit.id) === parseInt(unitId)) isAlreadyAdded = true;
				}
				
				if (!isAlreadyAdded) {
					resultUsers.push(person);
				}
			}

			return resultUsers;
		}
	} catch (err) {
		console.error("Error fetching users:", err);
		return err.response;
	}
}

export async function deleteUnitMember(axiosPrivate, cb, unitId, userId) {
	return axiosPrivate
		.delete(`${apiURL}/organization-unit/${unitId}/member/${userId}.json`)
		.then((res) => {
			if (res.status > 199 && res.status < 300) {
				toast.success("Member removed");
				cb();
			} else {
				toast.error("Could not remove member. Please try again.");
			}
		})
		.catch((err) => {
			toast.error(apiErrorMessage(err, "Member failed to be removed"));
			return err.response;
		});
}

export async function addUnitMembers(axiosPrivate, cb, unitId, data) {
	return axiosPrivate
		.post(`${apiURL}/organization-unit/${unitId}/member.json`, data)
		.then((res) => {
			if (res.status > 199 && res.status < 300) {
				toast.success("Member added");
				cb();
			} else {
				toast.error("Could not add member. Please try again.");
			}
			return res;
		})
		.catch((err) => {
			toast.error(apiErrorMessage(err, "Member failed to be added"));
			return err.response;
		});
}

export async function changeUnitMemberRole(axiosPrivate, cb, unitId, userId, data) {
	return axiosPrivate
		.put(`${apiURL}/organization-unit/${unitId}/member/${userId}.json`, data)
		.then((res) => {
			if (res.status > 199 && res.status < 300) {
				toast.success("Member roles updated");
				cb();
			} else {
				toast.error("Could not update member roles. Please try again.");
			}
		})
		.catch((err) => {
			toast.error(apiErrorMessage(err, "Member roles failed to be changed"));
			return err.response;
		});
}
